import { DatePipe, Location } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription, Observable } from "rxjs";
import { tap, switchMap } from "rxjs/operators";
import { CertificateOfDeposit, FinancialInstrument, FinancialInstrumentType, LetterOfCredit } from '../../../common/models/financialAssurance.model';
import { FinancialAssuranceService } from '../../../common/services/financial-assurance.service';
import { SubHeader } from '../../../core/models/sub-header.model';
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { Organization } from '../../../common/models/organization.model';
import { OrganizationService } from '../../../common/services/organization.service';

@Component({
    selector: 'fa-instrument-details',
    templateUrl: './fa-instrument-details.component.html',
    standalone: false
})
export class FaInstrumentDetailsComponent implements OnInit, OnDestroy {

    instrument: FinancialInstrument;
    organization: Organization;

    subHeader = new SubHeader({
        title: "Financial Instrument Details", buttons: [
            { name: "Back", method: () => this.back() }
        ]
    });

    subscription: Subscription = new Subscription;

    typeDescriptions: any[] = [];

    constructor(public datePipe: DatePipe,
        public location: Location,
        public route: ActivatedRoute,
        public service: FinancialAssuranceService,
        public subHeaderService: SubHeaderService,
        public organizationService: OrganizationService) { }

    ngOnInit() {

        this.subHeaderService.updateSubHeader(this.subHeader);

        this.instrument = this.route.snapshot.data.instrument;
        let obs$: Observable<any> = this.service.TypeDescriptions.pipe(
            tap((data: any[]) => {
                this.typeDescriptions = data;
            })
        );


        if (this.instrument != null) {
            obs$ = obs$.pipe(
                switchMap(() => {
                    return this.organizationService.getOrganization(this.instrument.organizationId).pipe(
                        tap((org: Organization) => {
                            this.organization = org;
                        })
                    )
                })
            );           
        }

        const subs$: Subscription = obs$.subscribe(
            () => { },
            (error) => { console.error(error); }
        );
        this.subscription.add(subs$);
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    back(): void {
        this.location.back()
    }

    getExpirationDate(): string {

        let expiryDate: Date;

        if (this.instrument.typeCode.toUpperCase() == FinancialInstrumentType.CD)
            expiryDate = (this.instrument as CertificateOfDeposit).maturityDate;
        

        if (this.instrument.typeCode.toUpperCase() == FinancialInstrumentType.LetterOfCredit)
            expiryDate = (this.instrument as LetterOfCredit).expirationDate;

        if (this.instrument.expirationDate)
            expiryDate = this.instrument.expirationDate

        return expiryDate ? this.datePipe.transform(expiryDate) : '';
    }

    getInstrumentType(): string {
        //return this.service.getTypeDescription(this.instrument.typeCode);
        let match = this.typeDescriptions.find(t => t.id == this.instrument.typeCode);
        if (match != null) return match.description;
        return this.instrument.typeCode;
    }

    phoneFormatter(phone: string) {
        if (!phone) return '';
        if (phone.length === 10) return phone.substr(0, 3) + '-' + phone.substr(3, 3) + '-' + phone.substr(6, 4);
        return phone;
    }

}
